import { component } from "picoapp";
import { CAROUSEL_INTERSECTION_SETTINGS } from "../Carousels/tbsp-carousel--constants";

export const explodingPan = component(async (node: HTMLElement) => {
  const [{ default: Splide }, { Intersection }] = await Promise.all([
    import("@splidejs/splide"),
    import("@splidejs/splide-extension-intersection"),
    import("@splidejs/splide/css/core"),
  ]);

  const carousel = node.querySelector<HTMLElement>(".splide");
  if (!carousel) {
    return;
  }

  const mainCarousel = new Splide(carousel, {
    arrows: false,
    drag: false,
    speed: 0,
    pagination: true,
    paginationDirection: "ttb",
    focus: 0,

    ...CAROUSEL_INTERSECTION_SETTINGS,
  });

  mainCarousel.on("pagination:mounted", ({ items, list }) => {
    list.classList.add("flex-row", "md:flex-col", "!flex");
    items.forEach((item, idx) => {
      item.button.classList.add("ripple-button");
      item.button.textContent = String(item.page + 1);
      const liClass = ["md:!mb-6", "!mr-6", "md:!mr-0", "ripple", "last:!mr-0"];
      item.li.classList.add(...liClass);

      const hotspotButtons = node.querySelectorAll<HTMLElement>(
        "[data-tbsp-hotspot] button"
      );
      const target = idx < hotspotButtons.length ? hotspotButtons[idx] : null;

      if (target) {
        Object.keys(target.dataset).forEach((k) => {
          const value = target.dataset[k];
          if (value !== undefined) {
            item.button.dataset[k] = value;
          }
        });
        const ariaControls = item.button.getAttribute("aria-controls");
        if (ariaControls) {
          target.setAttribute("aria-controls", ariaControls);
        }
      }
    });
  });

  mainCarousel.on("mounted", () => {
    const hotSpots = node.querySelectorAll<HTMLElement>("[data-tbsp-hotspot]");
    hotSpots.forEach((hotSpot) =>
      hotSpot.addEventListener("click", () => {
        const index = hotSpot.dataset.index;
        if (index) {
          const parsedIndex = parseInt(index, 10);
          if (!isNaN(parsedIndex)) {
            mainCarousel.Components.Controller.go(parsedIndex, false);
          }
        }
      })
    );
  });

  mainCarousel.on("active", (Slide) => {
    const activeIndex = Slide.index;
    const activeHotSpot = node.querySelector(`[data-tbsp-hotspot] .is-active`);
    if (activeHotSpot) {
      activeHotSpot.classList.remove("is-active");
    }
    const newHotSpot = node.querySelector(
      `[data-tbsp-hotspot][data-index='${activeIndex}']`
    );
    const newHotSpotButton = newHotSpot?.querySelector("button");
    if (newHotSpotButton) {
      newHotSpotButton.classList.add("is-active");
    }
  });

  mainCarousel.mount({ Intersection });
});
